import Vue from 'vue'
//import router from './router'
// 引入根视图应用
import App from './App.vue'
// 引入组件库
import iView from '@/components';
// 引入全局样式
import "@/styles/index.less";

console.log(JSON.stringify(process.env))

// 如果是非线上环境，不加载 VConsole
if (process.env.NODE_ENV !== 'production') {
    var VConsole = require('vconsole/dist/vconsole.min.js')
    var vConsole = new VConsole()

    Vue.config.performance = true;
}

Vue.use(iView)

new Vue({
  //router,
  render: h => h(App)
}).$mount('#app')
